<template>
<div class="sidebar-label d-flex align-items-center">
  <div class="sidebar-label__icon d-flex justify-content-center align-items-center" v-b-tooltip.hover :title="title">
    <ez-icon :icon="icon" size="14"></ez-icon>
  </div>
  <span class="sidebar-label__text">
    <slot></slot>
  </span>
</div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    icon: {
        type: String,
        default: "ezAr-icon-golf-practice"
    }
  },
};
</script>
<style lang="scss" scoped>
.sidebar-label {
  &__icon {
    width: 24px;
    height: 24px;
    background-color: #f3f3f4;
    border-radius: 5px;
  }
  &__text {
    margin-left: 8px;
  }
  .tooltip {
    
  }
}
</style>
